<template>
  <!-- Reusable "select a company" empty-state prompt. Shown on portal
       pages (dashboard, Documents, Search, SavedCarts) when no company
       is selected. Presentational only — the host page owns the v-if
       gating on its own companySelected state. -->
  <div class="admin-welcome-card">
    <div class="admin-welcome-inner">
      <div class="admin-welcome-badge">Admin</div>
      <h1 class="admin-welcome-title">
        Welcome, {{ userName }}!
      </h1>
      <p class="admin-welcome-message">
        Please select a company from the dropdown in the header to get started.
      </p>
      <div class="admin-welcome-hint">
        Use the <strong>Company Selector</strong> at the top of the page
        to choose which company you want to work with.
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
          viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="admin-welcome-arrow">
          <line x1="12" y1="19" x2="12" y2="5"></line>
          <polyline points="5 12 12 5 19 12"></polyline>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectCompanyPrompt",
  props: {
    userName: {
      type: String,
      default: "Admin",
    },
  },
};
</script>

<style scoped>
/* ===== ADMIN WELCOME (shown when no company is selected) =====
   Copied verbatim from Account/Index.vue's #adminWelcome / .admin-welcome-*
   rules so this component stands alone. The id-based #adminWelcome wrapper
   selector was folded into .admin-welcome-card (with its own top/bottom
   padding) so the card spaces itself without the id wrapper. */
.admin-welcome-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-left: 4px solid #c0392b;
  border-radius: 8px;
  padding: 36px 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  max-width: 760px;
  margin: 40px auto 24px;
}

.admin-welcome-inner {
  text-align: left;
}

.admin-welcome-badge {
  display: inline-block;
  background: #c0392b;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 4px 12px;
  border-radius: 4px;
  margin-bottom: 14px;
}

.admin-welcome-title {
  font-size: 28px;
  font-weight: 700;
  color: #222;
  margin: 0 0 12px;
  line-height: 1.2;
}

.admin-welcome-message {
  font-size: 16px;
  color: #555;
  line-height: 1.5;
  margin-bottom: 24px;
}

.admin-welcome-hint {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #faf6f5;
  border: 1px solid #f0e4e1;
  border-radius: 6px;
  padding: 14px 18px;
  font-size: 14px;
  color: #555;
  line-height: 1.5;
}

/* Arrow now sits AFTER the hint text (right side), so the spacing
   reservation flips from margin-right to margin-left. */
.admin-welcome-arrow {
  flex-shrink: 0;
  color: #c0392b;
  margin-top: 2px;
  margin-left: 2px;
  animation: welcomeBounce 1.8s ease-in-out infinite;
}

.admin-welcome-hint strong {
  color: #c0392b;
}

@keyframes welcomeBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

@media (max-width: 767.98px) {
  .admin-welcome-card {
    padding: 24px 20px;
  }
  .admin-welcome-title {
    font-size: 22px;
  }
  .admin-welcome-message {
    font-size: 14px;
  }
}
</style>
